import React from 'react';

const LeftTray = ({ isOpen, activePanelType, onPanelChange }) => {
  return (
    <div className={`left-tray ${isOpen ? 'open' : ''}`}>
      <button
        className={`tray-button ${activePanelType === 'chat' ? 'active' : ''}`}
        onClick={() => onPanelChange(activePanelType === 'chat' ? null : 'chat')}
        title="Previous Chats"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </button>

      <button
        className={`tray-button ${activePanelType === 'conversation' ? 'active' : ''}`}
        onClick={() => onPanelChange(activePanelType === 'conversation' ? null : 'conversation')}
        title="Conversation Mode"
      >
        <svg 
          xmlns="http://www.w3.org/2000/svg" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2"
        >
          <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
          <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
          <line x1="12" y1="19" x2="12" y2="23" />
          <line x1="8" y1="23" x2="16" y2="23" />
        </svg>
      </button>
    </div>
  );
};

export default LeftTray; 